import React from 'react'
import { Input } from 'components/inputs'
import { FilterOptions } from './filterOptions'

export const NumericFilter = ({ localize, column, update, classes }) => {
  const handleOnChange = React.useCallback((value) => update({ value }), [update])
  return (
    <div>
      <FilterOptions localize={localize} classes={classes} column={column} update={update}  />
      <Input isNumeric value={column.value} onChange={handleOnChange} />
    </div>
  )
}